class RequestException extends Error {
    constructor(message, status) {
        super(message);
        this.name = "RequestException";
        this.status = status;
    }
}

export default RequestException;